"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogin = useLogin;
const webapi_1 = require("@fegobull/webapi");
function useLogin(defaults) {
    const { useUser, useBehaviour } = webapi_1.use;
    const { isLogin, uid } = useUser();
    const { runBehaviour } = useBehaviour();
    function toLogin(overrides) {
        runBehaviour(null, {
            type: 'login',
            withQuery: false,
            ...defaults,
            ...overrides,
        });
    }
    return {
        uid,
        isLoggedIn: isLogin,
        toLogin,
    };
}
